import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { OperatorLookupReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: OperatorLookupReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operationIds: report.operationIds,
    msisdns: report.msisdns
  }
});
